<div class="p-3">
  <div class="row">
    <div class="col-sm-4">
      <h3>Notifications</h3>
    </div>
  </div>
  <!-- <div class="col-md-4 p-0">
  <span class="d-block count col-md-7">Notifications: {{count || 0}}</span>
</div> -->
<div class="row mt-2">
  <div class="col-xs-12 col-sm-12 col-md-4">
    <div>
      <label class="m-0">Search</label>
    </div>
    <div class="rounded position-relative">
      <input type="text" class="form-control" placeholder="Notification" (keyup.enter)="pageNumber = 1;dataParams.offset = 0; initialNotifications();"
        [(ngModel)]="search">
        @if (hadSearched) {
          <span class="pt-2 custom-border px-3 position-absolute pull-right rounded"
            (click)="search='';pageNumber = 1;dataParams.offset = 0;initialNotifications()">
            <i class="fa fa-close"></i>
          </span>
        }
      </div>
    </div>
    <div class="col-sm-4 col-md-4 row m-0">
      <div class="mt-4 px-2" style="width: 33%;">
        <div class="checkbox c-checkbox" style="font-weight: 800;">
          <input tappable class="secondary-radio" type="radio" name="filter-0" [value]="'0'" [(ngModel)]="filter" id="filter-0"
            (change)="pageNumber = 1;dataParams.offset = 0;initialNotifications()" />
            <label tappable class="fs-14 fw-500 m-0 hex-65-grey" for="filter-0">
              <!-- <span class="fa fa-check"></span> -->
              All ({{count || 0}})
            </label>
          </div>
        </div>
        <div class="mt-4 ml-3" style="width: 33%;">
          <div class="" style="font-weight: 800;">
            <input tappable class="secondary-radio" type="radio" name="filter-1" [value]="'1'" [(ngModel)]="filter" id="filter-1"
              (change)="pageNumber = 1;dataParams.offset = 0;initialNotifications()" />
              <label tappable class="fs-14 fw-500 m-0 hex-65-grey" for="filter-1">
                <!-- <span class="fa fa-check"></span> -->
                Read ({{ count - unread_count || 0}})
              </label>
            </div>
          </div>
          <div class="mt-4 ml-3" style="width: 33%;">
            <div class="checkbox c-checkbox" style="font-weight: 800;">
              <input tappable class="secondary-radio" type="radio" name="filter-2" [value]="'2'" [(ngModel)]="filter" id="filter-2"
                (change)="pageNumber = 1;dataParams.offset = 0;initialNotifications()" />
                <label tappable class="fs-14 fw-500 m-0 hex-65-grey" for="filter-2">
                  <!-- <span class="fa fa-check"></span> -->
                  Unread ({{ unread_count || 0}})
                </label>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-md-4">
            @if (selected_notification) {
              <button class="btn btn-primary mt-4 pull-right"
              (click)="navToNotification(selected_notification, 0)">View Details</button>
            }
          </div>
        </div>
        <!-- <div class="text-center contract-loader" *ngIf="initialLoader">
        <div class="line-scale">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div> -->
      <!-- style="max-height: 80vh;overflow: auto;" infinite-scroll [infiniteScrollDistance]="2" (scrolled)="onScrollDown()" [scrollWindow]="false" -->
      <div class="mt-4">
        <ul class="list-group">
          @if (notifications && notifications.length > 0) {
            <div class="row">
              <div class="col-sm-4">
                @if (unread_count && unread_count>=1) {
                  <div class="text-right mb-1">
                    <a class="pointer" (click)="markRead('','')">Mark All as Read</a>
                  </div>
                }
                @for (notification of notifications; track notification; let i = $index) {
                  <li class="list-group-item d-flex justify-content-between align-items-center mb-1"
                    [ngClass]="{'bg-primary':(!notification.read_at || notification.read_at==null),'selected-notification': selected_notification == notification}"
                    (click)="showNotificationDetails(notification, i)" tappable style="cursor: pointer;" >
                    <div style="cursor: pointer;">
                      <p class="mb-1">
                        <!-- <i *ngIf="notification.notification_type == 1 || notification.notification_type == 2 || notification.notification_type == 3 || notification.notification_type == 4 || notification.notification_type == 5"
                      class="fa fa-arrow-up text-danger"></i> -->
                      {{notification.title || notification.message}}<br/><span>
                      {{notification.message}}
                    </span></p>
                    <small>{{notification.sent_at | date:'MM-dd-yyyy hh:mm a':timezone}}
                    ({{timezoneName?timezoneName:''}})</small>
                    <!-- <br><span *ngIf="notification.read_at">Read At ::{{notification.read_at}}</span> -->
                  </div>
                  <div style="display: flex;">
                    @if ((!notification.read_at || notification.read_at==null)) {
                      <i class="fa fa-envelope-open-o" aria-hidden="true"
                        (click)="markNotificationAsRead($event, notification, i)" data-container="body" data-placement="top"
                      tooltip="Mark as read" style="z-index: 101;margin-right: 5px;"></i>
                    }
                    <i class="ml-2 fa fa-trash " (click)="deleteNotification($event, notification)" style="z-index: 101;"
                    data-container="body" data-placement="top" tooltip="Delete"></i>
                  </div>
                </li>
              }
              <div class="mt-4">
                <pagination class="pagination-sm float-md-right" [totalItems]="number_of_pages" [maxSize]="3"
                  [boundaryLinks]="true" [rotate]="false" [(ngModel)]="pageNumber" (pageChanged)="pageChanged($event)">
                </pagination>
              </div>
            </div>
            <div class="col-sm-8 detail-contoller">
              @if (selected_notification.notification_type == 4 || selected_notification.notification_type == 5 || selected_notification.notification_type == 13 || selected_notification.notification_type == 16 || selected_notification.notification_type == 17 || selected_notification.notification_type == 20 || selected_notification.notification_type == 30 || selected_notification.notification_type == 31 || selected_notification.notification_type == 32 || selected_notification.notification_type == 40) {
                <app-assignment-details
                  >
                </app-assignment-details>
              }
              @if (selected_notification.notification_type == 6 || selected_notification.notification_type == 15) {
                <app-training-details
                  >
                </app-training-details>
              }
              <!-- <app-doctor-profile *ngIf="selected_notification.notification_type == 1">
            </app-doctor-profile>
            <app-marketing-details
              *ngIf="selected_notification.notification_type == 3 || selected_notification.notification_type == 14">
            </app-marketing-details>
            <app-partner-profile *ngIf="selected_notification.notification_type == 2">
            </app-partner-profile>
            <app-lead-create *ngIf="selected_notification.notification_type == 8"></app-lead-create>
            <app-event-details
              *ngIf="selected_notification.notification_type == 7 || selected_notification.notification_type == 18">
            </app-event-details> -->
          </div>
        </div>
      }
      @if (!notifications || notifications.length == 0) {
        <div class="text-center mt-5">
          <i class='fa fa-bell-slash' style='font-size:48px;color:#0A6B89'></i>
          <h4 class="mt-3">No Notifications</h4>
        </div>
      }
    </ul>
  </div>
  <!-- <div id="refreshPopup1" class='refresh_popup refresh_popup_dismiss noselect'>
  <p class="mb-0 mt-2"> <b style="font-size:15px;">There are some new notifications, please refresh to be in sync with the latest notifications.</b>
  <br>
    <button class="notifi-details-btn" tappable (click)="updateNewNotifications();" >Refresh</button>
  </p>
  <button class="close pull-right close-notification-btn" (click)="removeNotification()" type="button"> × </button>
</div> -->

<div id="refreshPopup1" class='refresh_popup refresh_popup_dismiss noselect'>
  <p class="mb-0 mt-2"> <b style="font-size:15px;">There are some new notifications, please refresh to be in sync with the latest notifications.</b>
  <br>
    <button class="notifi-details-btn" tappable (click)="updateNewNotifications();" >Refresh</button>
  </p>
  <button class="close pull-right close-notification-btn" (click)="removeNotification()" type="button"> × </button>
</div>
</div>